module.exports = __webpack_public_path__ + "img/silla.cbba6cb5.svg";